module.exports = __webpack_public_path__ + "img/defaultlogo.b8a7db0a.jpg";